<template>
  <div class="community-setting-manage-container">
    <el-row :gutter="20">
      <el-col :span="4">
        <el-card class="setting-type-card">
          <div class="setting-type-list">
            <div v-for="(item, index) in settingTypes" :key="index" class="setting-type-item"
              :class="{ 'active': conditions.settingType === item.statusCd }" @click="handleSwitchSettingType(item)">
              {{ item.name }}
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="20">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>{{ currentSettingName }}</span>
            <span />
          </div>
          <div class="setting-content text-left">
            <el-form label-position="right" label-width="150px">
              <el-form-item v-for="(item, index) in settingKeys" :key="index" :label="item.settingName">
                <!-- 员工选择器 -->
                <div v-if="isStaffSelect(item)" class="staff-select-wrapper">
                  <el-tag
                    v-for="(staff, si) in getSelectedStaffList(item)"
                    :key="si"
                    closable
                    type="info"
                    class="staff-tag"
                    @close="removeSelectedStaff(item, si)">
                    {{ staff.staffName }}
                  </el-tag>
                  <el-button size="small" type="primary" icon="el-icon-plus" @click="openStaffSelect(item)">
                    选择员工
                  </el-button>
                </div>
                <!-- 默认文本输入 -->
                <el-input v-else v-model="item.settingValue"
                  :placeholder="$t('communitySettingManage.inputPlaceholder', { name: item.settingName })" />
                <div class="setting-remark" v-if="!isStaffSelect(item)">{{ item.remark }}</div>
                <div class="setting-remark" v-else>{{ cleanRemark(item.remark) }}</div>
              </el-form-item>
            </el-form>
            <div class="setting-tips">{{ $t('communitySettingManage.settingTips') }}</div>
            <div class="text-right">
              <el-button type="primary" @click="handleSaveSettings">
                <i class="el-icon-check"></i>
                {{ $t('common.submit') }}
              </el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <select-staff ref="selectStaff" @selectStaff="handleStaffSelected"></select-staff>
  </div>
</template>

<script>
import { getCommunityId, getCommunity } from '@/api/community/communityApi'
import { getDict } from '@/api/community/communityApi'
import {
  listCommunitySettingKey,
  saveCommunitySetting
} from '@/api/system/communitySettingManageApi'
import SelectStaff from '@/components/staff/SelectStaff.vue'
import request from '@/utils/request'

export default {
  name: 'CommunitySettingManageList',
  components: {
    SelectStaff
  },
  data() {
    return {
      communityId: '',
      storeId: '',
      settingTypes: [],
      settingKeys: [],
      currentSettingName: '',
      currentStaffItem: null,
      conditions: {
        settingType: '',
        communityId: ''
      },
      // 用户组织上下文（传给 SelectStaff）
      userOrgIds: [],
      currentOrgId: '',
      userRole: 'normal'
    }
  },
  created() {
    this.communityId = getCommunityId()
    var storeInfo = JSON.parse(localStorage.getItem('storeInfo') || '{}')
    this.storeId = storeInfo.storeId || getCommunity().storeId || ''
    this.conditions.communityId = this.communityId
    this.initData()
  },
  methods: {
    async initData() {
      try {
        await this._initUserContext()
      } catch (e) {
        console.error('[communitySetting] initUserContext failed:', e)
      }
      // 如果 _initUserContext 失败，默认使用 manager 角色（可查看所有部门）
      if (!this.userRole || this.userRole === 'normal') {
        this.userRole = 'manager'
      }
      try {
        const data = await getDict('community_setting_key', 'setting_type')
        this.settingTypes = data
        if (data && data.length > 0) {
          this.handleSwitchSettingType(data[0])
        }
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _initUserContext() {
      var userInfo = JSON.parse(localStorage.getItem('user') || '{}')
      var staffId = userInfo.userId || userInfo.staffId || ''
      if (!staffId) {
        console.warn('[communitySetting] no staffId in localStorage, using default manager role')
        return
      }

      var relRes = await request({
        url: '/orgStaffRel.listOrgStaffRel',
        method: 'get',
        params: { staffId: staffId, storeId: this.storeId, page: 1, row: 50 }
      })
      var respBody = relRes.data || {}
      var rels = Array.isArray(respBody.data) ? respBody.data : (Array.isArray(respBody) ? respBody : [])

      var maxRelCd = 0
      var inSupervisorDept = false
      var hasOrgPosition = false

      for (var k = 0; k < rels.length; k++) {
        var r = rels[k]
        var orgName = r.orgName || r.org_name || ''
        var orgId = r.orgId || r.org_id || ''
        var rc = parseInt(r.relCd || r.rel_cd || '0') || 0

        this.userOrgIds.push(orgId)

        var isPlatformCode = (rc === 600311000001 || rc === 600311000002)
        if (!isPlatformCode && rc > maxRelCd) {
          maxRelCd = rc
          this.currentOrgId = orgId
        }
        if (!isPlatformCode) hasOrgPosition = true

        if (orgName.indexOf('主管部') !== -1) {
          inSupervisorDept = true
        }
      }

      if (maxRelCd >= 2000) {
        this.userRole = inSupervisorDept ? 'supervisor_manager' : 'manager'
      } else if (inSupervisorDept && hasOrgPosition) {
        this.userRole = 'supervisor'
      }
    },
    async handleSwitchSettingType(item) {
      this.conditions.settingType = item.statusCd
      this.currentSettingName = item.name
      await this.loadSettingKeys()
    },
    async loadSettingKeys() {
      try {
        const params = {
          communityId: this.communityId,
          settingType: this.conditions.settingType
        }
        const { data } = await listCommunitySettingKey(params)
        this.settingKeys = data.map(item => {
          return {
            ...item,
            settingValue: item.settingValue || ''
          }
        })
      } catch (error) {
        console.error('获取设置项失败:', error)
      }
    },
    async handleSaveSettings() {
      try {
        const params = {
          communityId: this.communityId,
          keys: this.settingKeys,
          settingType: this.conditions.settingType
        }
        const { code, msg } = await saveCommunitySetting(params)
        if (code != 0) {
          this.$message.error(msg)
          return;
        }
        this.$message.success(this.$t('common.operationSuccess'))
        this.loadSettingKeys()
      } catch (error) {
        console.error('保存设置失败:', error)
      }
    },
    // --- 员工选择器相关 ---
    isStaffSelect(item) {
      return item.settingKey === 'SUPERVISOR_STAFF' || (item.remark && item.remark.indexOf('[STAFF_SELECT]') > -1)
    },
    cleanRemark(remark) {
      return remark ? remark.replace('[STAFF_SELECT]', '') : ''
    },
    getSelectedStaffList(item) {
      if (!item.settingValue) return []
      try {
        return JSON.parse(item.settingValue)
      } catch (e) {
        return []
      }
    },
    openStaffSelect(item) {
      this.currentStaffItem = item
      this.$refs.selectStaff.open({
        adminMode: true
      })
    },
    handleStaffSelected(staff) {
      if (!this.currentStaffItem) return
      const staffId = staff.staffId || staff.userId
      const staffName = staff.staffName || staff.userName || staff.name
      let list = []
      try {
        list = JSON.parse(this.currentStaffItem.settingValue || '[]')
      } catch (e) {
        list = []
      }
      // 防止重复添加
      if (!list.find(s => s.staffId === staffId)) {
        list.push({ staffId, staffName })
      }
      this.currentStaffItem.settingValue = JSON.stringify(list)
      this.currentStaffItem = null
    },
    removeSelectedStaff(item, index) {
      let list = []
      try {
        list = JSON.parse(item.settingValue || '[]')
      } catch (e) {
        list = []
      }
      list.splice(index, 1)
      item.settingValue = JSON.stringify(list)
    }
  }
}
</script>

<style lang="scss" scoped>
.community-setting-manage-container {
  padding: 20px;

  .setting-type-card {
    height: 100%;

    .setting-type-list {
      .setting-type-item {
        padding: 10px;
        margin-bottom: 5px;
        cursor: pointer;
        border-radius: 4px;
        text-align: center;

        &:hover {
          background-color: #f5f7fa;
        }

        &.active {
          background-color: #409eff;
          color: white;
        }
      }
    }
  }

  .setting-content {
    padding: 20px;

    .setting-remark {
      margin-top: 5px;
      font-size: 12px;
      color: #909399;
    }

    .setting-tips {
      margin: 20px 0;
      font-size: 12px;
      color: #f56c6c;
    }
  }

  .staff-select-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;

    .staff-tag {
      margin-bottom: 4px;
    }
  }
}
</style>
